export default {
    getBookingForm: (state) => {
        return state.bookingForm
    },
    getBooking: (state) => {
        return state.booking
    },
    getBookingChangelog: (state) => {
        return state.bookingChangelog
    },
    getFollowOnJobsForTaxi: (state) => {
        return state.followOnJobsForTaxi
    }
}
